const TAB_SLUGS = {
	1: "issues",
	2: "work-orders",
	3: "activity-log",
	4: "vehicle-details",
};

export const DEFAULT_TAB_VALUE = 1;

export const tabSlugFromValue = (value: number) =>
	TAB_SLUGS[value] ?? TAB_SLUGS[DEFAULT_TAB_VALUE];

export const tabValueFromSlug = (slug: string) => {
	const entry = Object.entries(TAB_SLUGS).find(([, s]) => s === slug);
	return entry ? Number(entry[0]) : undefined;
};

export const vehicleTabPath = (vehicleId: string | number, value: number) =>
	`/maintenance-repair/${vehicleId}/${tabSlugFromValue(value)}`;
